import layout_bravo_cloud from 'app/fuse-layouts/bravo_cloud/BravoCloud';

const FuseLayouts = {
    layout_bravo_cloud,
};

export default FuseLayouts;
